import { ContextStore } from 'bernie-plugin-mobx';

import { adaptSearchCriteria } from 'stores/adapters/bex-api/common/search-criteria-adapter';
import { CurrentHotelStore } from 'stores/current-hotel-store';
import { getShoppingContextInput } from 'stores/adapters';
import { InfositeQueryAdapter } from 'stores/adapters/infosite-query-adapter';

import { MultiItemContext } from 'models/multi-item/multi-item-types';
import { PropertyTravelAdTrackingInfoInput, SearchOfferInput, SearchOfferPriceInput, SelectedValueInput } from '__generated__/api/types';

import { SharedUiWrapperProps } from 'components/infosite/shared-ui/offers/shared-ui-property-offers';

export const getPropertyOffersInput = (
  context: ContextStore,
  currentHotel: CurrentHotelStore,
  urlParameters: Partial<Record<string, string>>,
  multiItemContext?: MultiItemContext
): SharedUiWrapperProps['inputs'] => {
  const { searchCriteria, hotelId, l10n } = currentHotel;

  const searchCriteriaJson = searchCriteria?.toJSON() || {};
  const criteria = {
    ...InfositeQueryAdapter.parseOut(searchCriteriaJson, l10n),
    ...searchCriteriaJson,
  };

  const {
    selectedRatePlan,
    selectedRoomType,
    badgeType,
    top_dp: srpDisplayPrice,
    top_cur: srpCurrency,
    mipt: multiItemPriceToken,
    pwa_ts: offerTimestamp,
    rfrr: referrer,
  } = urlParameters;

  return {
    propertyId: String(hotelId),
    searchCriteria: adaptSearchCriteria(context, criteria),
    shoppingContext: getShoppingContextInput(multiItemContext),
    travelAdTrackingInfo: getTravelAdTrackingInfo(criteria),
    searchOffer: getSearchOffer(
      selectedRoomType,
      selectedRatePlan,
      badgeType,
      multiItemPriceToken,
      srpDisplayPrice,
      srpCurrency,
      offerTimestamp
    ),
    referrer,
  };
};

export const getTravelAdTrackingInfo = (criteria: any): PropertyTravelAdTrackingInfoInput | null => {
  if (criteria.trackingData) {
    return {
      beaconIssued: criteria.beaconIssued,
      candidateHmGuid: criteria.candidateHmGuid,
      position: criteria.position,
      rank: criteria.rank,
      slots: criteria.slots,
      testVersionOverride: criteria.testVersionOverride,
      trackingData: criteria.trackingData,
    };
  }

  return null;
};

export const getSearchOffer = (
  selectedRoomType?: string,
  selectedRatePlan?: string,
  badgeType?: string,
  multiItemPriceToken?: string,
  srpDisplayPrice?: string,
  srpCurrency?: string,
  offerTimestamp?: string
): SearchOfferInput | null => {
  if (selectedRoomType && selectedRatePlan) {
    return {
      offerPrice: getOfferPrice(multiItemPriceToken, srpDisplayPrice, srpCurrency, offerTimestamp),
      roomTypeId: selectedRoomType,
      ratePlanId: selectedRatePlan,
      offerDetails: getOfferDetails(badgeType),
    };
  }

  return null;
};

export const getOfferDetails = (badgeType?: string): SelectedValueInput[] =>
  badgeType ? [{ id: 'selectedRoomBadgeType', value: 'brandedDeal' }] : [];

export const getOfferPrice = (
  priceToken?: string | null,
  srpDisplayPrice?: string | null,
  srpCurrency?: string | null,
  offerTimestamp?: string | null
): SearchOfferPriceInput | null => {
  if (priceToken || (srpDisplayPrice && srpCurrency)) {
    return {
      multiItemPriceToken: priceToken,
      offerTimestamp,
      price:
        (srpDisplayPrice && {
          amount: Number(srpDisplayPrice),
          currency: srpCurrency,
        }) ||
        null,
    };
  }

  return null;
};
